import * as actionTypes from "./loader.action-types";
import { createAction } from "../utils";

export const showLoader = (data) => createAction(actionTypes.SHOW_LOADER, data);

export const removeLoader = (data) =>
  createAction(actionTypes.REMOVE_LOADER, data);
